module.exports = __webpack_public_path__ + "static/media/iclinicpay-azul.97f494a2.svg";